export const idGenerator = (): string => {
  const randomValues = new Uint32Array(2);
  globalThis.crypto.getRandomValues(randomValues);

  return `l${Array.from(randomValues, (value) => value.toString(36).padStart(7, '0')).join('')}`;
};

export const generateStatusLabel = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
